import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { VsCodeAuthContext } from '../../contextApis/vsCodeAuthContext';
import API_ENDPOINTS from '../../apiLayer/vsCodeAuthAPIs/authAPIs';
import api from '../../API/baseURL';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';

const ForgotPasswordModal = () => {
  const [email, setEmail] = useState('');
  const { loading, setLoading, setError } = useContext(VsCodeAuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await api.post(API_ENDPOINTS.FORGOT_PASSWORD, { email });
      navigate('/vscode/reset-password', { state: { email } });
    } catch (err) {
      setError(err.response?.data?.message || err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4 w-full">
      <div className="text-center">
        <h2 className="text-xl font-bold text-white mb-2">Forgot Password</h2>
        <p className="text-sm text-muted-foreground">Enter your email to receive a reset code.</p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          type="email"
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="bg-black/20 border-white/10"
        />
        <Button 
          type="submit" 
          disabled={loading}
          className="w-full bg-gradient-to-r from-primary to-purple-600 hover:opacity-90"
        >
          {loading ? 'Sending...' : 'Send Reset Code'}
        </Button>
      </form>
    </div>
  );
};

export default ForgotPasswordModal;
